<template>
  <div
    ref="authMain"
    class="relative flex flex-col portrait:w-full justify-center items-center overflow-y-auto no-scrollbar landscape:pt-8 landscape:pb-8"
  >
    <div
      class="bg-white relative p-5 portrait:pt-8 landscape:rounded-lg portrait:top-0 portrait:h-screen landscape:shadow-lg w-full landscape:max-w-lg h-auto z-[1]"
    >
      <router-view v-slot="{ Component }">
        <transition
          name="slide-fade"
          mode="out-in"
          @before-enter="checkHeightAndZoom"
          @after-enter="checkHeightAndZoom"
          @after-leave="checkHeightAndZoom"
        >
          <component :is="Component" />
        </transition>
      </router-view>
    </div>
  </div>
</template>

<style scoped>
.slide-fade-enter-active,
.slide-fade-leave-active {
  transition:
    transform 0.5s cubic-bezier(0.4, 0, 0.2, 1),
    opacity 0.5s ease-in-out;
}
.slide-fade-enter,
.slide-fade-leave-to /* .slide-fade-leave-active in <2.1.8 */ {
  opacity: 0;
  transform: translateX(20px);
}

.no-scrollbar::-webkit-scrollbar {
  display: none;
}
.no-scrollbar {
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
}
</style>

<script>
export default {
  name: "authLayout",
  data() {
    return {
      isLandscape: window.innerWidth > window.innerHeight,
    };
  },
  mounted() {
    if (document.readyState === "complete") {
      this.checkHeightAndZoom();
    } else {
      window.addEventListener("load", this.checkHeightAndZoom);
    }
    window.addEventListener(
      "resize",
      this.debounce(this.checkHeightAndZoom, 150)
    );
  },
  beforeUnmount() {
    window.removeEventListener(
      "resize",
      this.debounce(this.checkHeightAndZoom, 150)
    );
    window.removeEventListener("load", this.checkHeightAndZoom);
  },
  watch: {
    $route() {
      this.$nextTick(() => {
        this.checkHeightAndZoom();
      });
    },
  },
  methods: {
    debounce(fn, delay) {
      let timer;
      if (!this.isLandscape) {
        return;
      }
      return function (...args) {
        clearTimeout(timer);
        timer = setTimeout(() => fn.apply(this, args), delay);
      };
    },
    checkHeightAndZoom() {
      try {
        const authMainElement = this.$refs.authMain;
        const pageHeight = authMainElement.scrollHeight;
        const viewportHeight =
          window.visualViewport.height || window.innerHeight;

        if (pageHeight > viewportHeight) {
          let zoomFactor = (viewportHeight / pageHeight) * 100;
          if (zoomFactor < 70) {
            zoomFactor = 70;
          }
          document.body.style.zoom = `${zoomFactor}%`;
        } else {
          document.body.style.zoom = "100%";
        }
      } catch (error) {
        console.error(error);
      }
    },
  },
};
</script>
